import { Box, Button, Grid, Paper, TextField, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { getSetpoints, requestSetpoints, WELLPRO_REGISTERS } from "../../utils/controlConfig";
import { ProgressDialog } from "../plungerPage/progressPopup";
import axios from "../../utils/axiosInstance";
import { toast } from "react-toastify";
import { getUIDescription } from "../SiteAdmin/customerGroupDetails/AssigningCustomerGroupDevice";

export const WellProSetpointsCard = ({ unitId, data, fetchData }) => {
  const [wellProSetpoints, setWellProSetpoints] = useState({
    "Field Pressure PID SP [Bypass Valve- Load/Unload SP]": "",
    "Field Pressure PID DB [Bypass Valve- Load/Unload]": "",
    "Desired RPM output min": "",
    "Desired RPM output max": "",
    "Field Control SP [Split Injection Output SP]": "",
    "Field Control DB [Split Injection Output DB]": "",
    "HI Field Control SP [Split Injection Override SP]": "",
    "HI Field Control DB [Split Injection Override DB]": "",
  });
  const [progressOpen, setProgressOpen] = useState(false);
  const [progressSuccess, setProgressSuccess] = useState(false);
  const [progressError, setProgressError] = useState("");

  const fetchWellProSetpoints = async () => {
    if (!unitId) return;
    try {
      if (data) {
        setWellProSetpoints((prev) => ({
          ...prev,
          "Field Pressure PID SP [Bypass Valve- Load/Unload SP]":
            parseFloat(data._40271) / 10 ?? "",
          "Field Pressure PID DB [Bypass Valve- Load/Unload]":
            parseFloat(data._40272) / 10 ?? "",
          "Desired RPM output min": data._40306 ?? "",
          "Desired RPM output max": data._40307 ?? "",
          "Field Control SP [Split Injection Output SP]":
            data._40339 ?? "",
          "Field Control DB [Split Injection Output DB]":
            data._40340 ?? "",
          "HI Field Control SP [Split Injection Override SP]":
            data._40337 ?? "200",
          "HI Field Control DB [Split Injection Override DB]":
            data._40338 ?? "5",
        }));
      }
    } catch (err) {
      console.error("Failed to get wellPro setpoints:", err);
    }
  };

    const validateFields = () => {
    const emptyFields = Object.entries(wellProSetpoints).filter(
      ([key, value]) => value === "" || value === null || value === undefined
    );
    return emptyFields.map(([key]) => key);
  };

  const updateWellProSetpoints = async () => {
    const missingFields = validateFields();
        if (missingFields.length > 0) {
          toast.error(`Please fill in the following fields: ${missingFields.join(", ")}`, {
            autoClose:5000
          });
          return;
        }
    try {
      const confirmed = window.confirm(
        "Are you sure you want to change the setpoints? Reminder: ALWAYS get Setpoints prior to doing the update. Please ignore if you already did"
      );
      if (!confirmed) return;
      const initialResp = await axios.post(
        `${process.env.REACT_APP_API_GATEAWAY}/iot/device_get_by_register/${unitId}`,
        WELLPRO_REGISTERS
      );
      const baseline = {
        time: Number(initialResp.data.data?.time || 0),
        response: initialResp.data.data?.response || {},
      };
      console.log("Initial baseline time", baseline)
      const sp = (label) => parseFloat(wellProSetpoints[label]) || 0;
      let cmd = "S";
      cmd += `,${270},${
        sp("Field Pressure PID SP [Bypass Valve- Load/Unload SP]") * 10
      }`;
      cmd += `,${271},${
        sp("Field Pressure PID DB [Bypass Valve- Load/Unload]") * 10
      }`;
      cmd += `,${338},${sp(
        "Field Control SP [Split Injection Output SP]"
      )}`;
      cmd += `,${339},${sp(
        "Field Control DB [Split Injection Output DB]"
      )}`;
      cmd += `,${305},${sp("Desired RPM output min")}`;
      cmd += `,${306},${sp("Desired RPM output max")}`;
      cmd += `,${336},${sp("HI Field Control SP [Split Injection Override SP]")}`;
      cmd += `,${337},${sp("HI Field Control DB [Split Injection Override DB]")}`;
      setProgressOpen(true);
      setProgressSuccess(false);
      await axios.post(
        `${process.env.REACT_APP_API_GATEAWAY}/iot/control/precision/cmd`,
        { unitId, cmd,UI_Description: `${getUIDescription()}\n Send Command to the controller \nCmd: ${cmd}`, },
        {
          headers: {
            id: "anything",
            "Content-Type": "application/json",
          },
        }
      );
      console.log("Sending command:", cmd);
      setTimeout(() => {
        requestSetpoints(
          unitId,
          "P,270,1,271,1,338,1,339,1,305,1,306,1,336,1,337,1",
          baseline,
          setProgressSuccess,
          setProgressError,
          setProgressOpen
        );
      }, 100);
    } catch (error) {
      console.log("Error to update WellPro setpoints", error);
    }
  };

  useEffect(() => {
    if (unitId) {
      fetchWellProSetpoints();
    }
  }, []);

  return (
    <Grid size={{ xs: 12, sm: 6, md: 4, lg: 4 }}>
      <Paper sx={{ p: 2, bgcolor: "#1e293b", borderRadius: 2 }}>
        <Typography sx={{ mb: 2, fontSize: 14 }}>Setpoints</Typography>

        <Box sx={{ display: "flex", gap: 1, mb: 2 }}>
          <Button
            variant="contained"
            color="primary"
            fullWidth
            sx={{ fontSize: { xs: "10px", sm: "11px", md: "12px" } }}
            onClick={() =>
              getSetpoints(
                unitId,
                "P,270,1,271,1,338,1,339,1,305,1,306,1,336,1,337,1",
                setProgressSuccess,
                setProgressError,
                setProgressOpen
              )
            }
          >
            Get Setpoints
          </Button>
          <Button
            variant="contained"
            color="primary"
            fullWidth
            sx={{ fontSize: { xs: "10px", sm: "11px", md: "12px" } }}
            onClick={updateWellProSetpoints}
          >
            Update
          </Button>
        </Box>

        {Object.entries(wellProSetpoints).map(([label, value]) => (
          <Box key={label} sx={{ paddingBlock: 0.75 }}>
            <Typography sx={{ fontSize: 13 }}>{label}</Typography>
            <TextField
              variant="outlined"
              fullWidth
              size="small"
              value={value}
              onChange={(e) =>
                setWellProSetpoints((prev) => ({
                  ...prev,
                  [label]: e.target.value,
                }))
              }
              InputProps={{
                sx: {
                  color: "#fff",
                  backgroundColor: "#1f2937",
                  padding: 0.2,
                  fontSize: 13,
                },
              }}
            />
          </Box>
        ))}
      </Paper>
      <ProgressDialog
        open={progressOpen}
        isSuccess={progressSuccess}
        errorMessage={progressError}
        onClose={() => {
          setProgressOpen(false);
          setProgressError("");
        }}
        onRefresh={async () => {
          setProgressOpen(false);
          setProgressError("");
          await fetchData();
        }}
        loadingMessage="Check Device Response. Operation in-progress ..."
        successMessage="Successfully updated!"
      />
    </Grid>
  );
};
